var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    fill: "#242c33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,3 L17,4 L1,4 L1,3 L17,3 Z M3,17 L15,17 L15,5 L3,5 L3,17 Z M6,2 L12,2 L12,1 L6,1 L6,2 Z M12,0 C12.5125714,0 12.9354694,0.386285714 12.9932682,0.883431487 L13,1 L13,2 L17.051,2 C17.5375714,2 17.9387806,2.36645408 17.9936137,2.8383484 L18,2.949 L18,4.051 C18,4.53757143 17.6335459,4.93878061 17.1616516,4.9936137 L17.051,5 L16,5 L16,17.064 C16,17.5440714 15.6387194,17.9396429 15.1731687,17.9937037 L15.064,18 L2.936,18 C2.45592857,18 2.06035714,17.6387194 2.00629628,17.1731687 L2,17.064 L2,5 L0.949,5 C0.462428571,5 0.0612193878,4.63354592 0.00638629738,4.1616516 L0,4.051 L0,2.949 C0,2.46242857 0.366454082,2.06121939 0.838348397,2.0063863 L0.949,2 L5,2 L5,1 C5,0.487428571 5.38628571,0.0645306122 5.88343149,0.00673177843 L6,0 L12,0 Z M5.5,6 C5.225,6 5,6.225 5,6.5 L5,15.5 C5,15.775 5.225,16 5.5,16 C5.775,16 6,15.775 6,15.5 L6,6.5 C6,6.225 5.775,6 5.5,6 Z M12.5,6 C12.225,6 12,6.225 12,6.5 L12,15.5 C12,15.775 12.225,16 12.5,16 C12.775,16 13,15.775 13,15.5 L13,6.5 C13,6.225 12.775,6 12.5,6 Z M9,6 C8.725,6 8.5,6.225 8.5,6.5 L8.5,15.5 C8.5,15.775 8.725,16 9,16 C9.275,16 9.5,15.775 9.5,15.5 L9.5,6.5 C9.5,6.225 9.275,6 9,6 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.8effd0a9cd04236ecc5ef1a9a889bf42.svg";
export { ForwardRef as ReactComponent };